export const BRAND_SAFETY = {
    ALL: 'ALL',
    SAFE: 'SAFE',
};
